import { render, staticRenderFns } from "./ManageBlock.vue?vue&type=template&id=5812ba62&scoped=true&"
import script from "./ManageBlock.vue?vue&type=script&lang=js&"
export * from "./ManageBlock.vue?vue&type=script&lang=js&"
import style0 from "./ManageBlock.vue?vue&type=style&index=0&id=5812ba62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5812ba62",
  null
  
)

export default component.exports